import React from "react";

import UserRoutes from './routes/index';

import AppProvider from './hooks';

import './styles/global.scss';
import 'antd/dist/antd.css';

const App = () => {
  return (
    <div>
      <AppProvider>
        <UserRoutes />
      </AppProvider>
    </div>
  );
}

export default App;
